import { apiClient } from "../lib/api";

export const authApi = {
  login: (email, password) => apiClient.post("/auth/login", { email, password }),
  logout: () => apiClient.post("/auth/logout"),
  me: () => apiClient.get("/auth/me"),
  forgotPassword: (email) => apiClient.post("/auth/forgot-password", { email }),
  resetPassword: (token, new_password) => apiClient.post("/auth/reset-password", { token, new_password }),
  changePassword: (current_password, new_password) => apiClient.post("/auth/change-password", { current_password, new_password }),
  updateProfile: (name, email, current_password) => apiClient.patch("/auth/me", { name, email, current_password }),
  listUsers: () => apiClient.get("/users"),
  switchPortal: (portal) => apiClient.post("/auth/portal/switch", { portal }),
  createManagementUser: (payload) => apiClient.post("/users/management", payload),
  updateUserRole: (userId, role) => apiClient.patch(`/users/${userId}/role`, { role }),
  updateUserScope: (userId, location_scope, department_scope) => apiClient.patch(`/users/${userId}/scope`, { location_scope, department_scope }),
  suspendUser: (userId, reason) => apiClient.post(`/users/${userId}/suspend`, { reason }),
  reactivateUser: (userId) => apiClient.post(`/users/${userId}/reactivate`),
  revokeSessions: (userId) => apiClient.post(`/users/${userId}/revoke-sessions`),
  grantExtraPermissions: (userId, permissions) => apiClient.patch(`/users/${userId}/extra-permissions`, { permissions }),
  linkEmployee: (userId, employee_id) => apiClient.post(`/users/${userId}/link-employee`, { employee_id }),
  unlinkEmployee: (userId) => apiClient.post(`/users/${userId}/unlink-employee`),
};
